<template>
    <div :class="[css.wrapperClass]">
        <a 
            :class="['btn-nav', css.linkClass, isOnFirstPage ? css.disabledClass : '']"
            @click="loadPage(1)">
            <i 
                v-if="css.icons.first != ''" 
                :class="[css.icons.first]"/>
            <span v-else>&laquo;</span>
        </a>
        <a 
            :class="['btn-nav', css.linkClass, isOnFirstPage ? css.disabledClass : '']"
            @click="loadPage('prev')">
            <i :class="css.icons.prev"/>
        </a>
        <select 
            :class="['vuetable-pagination-dropdown', css.dropdownClass]" 
            @change="loadPage($event.target.selectedIndex+1)">
            <option 
                v-for="n in totalPage" 
                :class="[css.pageClass]" 
                :value="n" 
                :selected="isCurrentPage(n)">
                {{ pageText }} {{ n }}
            </option>
        </select>
        <a 
            :class="['btn-nav', css.linkClass, isOnLastPage ? css.disabledClass : '']"
            @click="loadPage('next')">
            <i :class="css.icons.next"/>
        </a>
        <a 
            :class="['btn-nav', css.linkClass, isOnLastPage ? css.disabledClass : '']"
            @click="loadPage(totalPage)">
            <i 
                v-if="css.icons.last != ''" 
                :class="[css.icons.last]"/>
            <span v-else>&raquo;</span>
        </a>
    </div>
</template>

<script>
import PaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';

export default {
    mixins: [PaginationMixin],
    props: {
        pageText: {
            type: String,
            default () {
                return 'Page';
            }
        }
    },
    created () {
        this.registerEvents();
    },
    methods: {
        registerEvents () {
            let self = this;

            this.$on('vuetable:pagination-data', (tablePagination) => {
                self.setPaginationData(tablePagination);
            });
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VuetablePaginationDropdownWithFirstAndLast.vue